export const SUPPORTED_LOCALES = ['en', 'de', 'ru', 'nl', 'zh', 'fi', 'it'];
export const DEFAULT_LOCALE = 'en';
export const NON_DEFAULT_LOCALES = SUPPORTED_LOCALES.filter((locale) => locale !== DEFAULT_LOCALE);

export const LOCALE_PREFIX = {
    en: '',
    de: 'de',
    ru: 'ru',
    nl: 'nl',
    zh: 'zh',
    fi: 'fi',
    it: 'it',
};

export const SEO_PAGE_LOCALES = {
    en: 'en_US',
    de: 'de_DE',
    ru: 'ru_RU',
    nl: 'nl_NL',
    zh: 'zh_CN',
    fi: 'fi_FI',
    it: 'it_IT',
};

/** BCP 47 tags for hreflang link elements. */
export const LOCALE_HREFLANG = {
    en: 'en',
    de: 'de',
    ru: 'ru',
    nl: 'nl',
    zh: 'zh-Hans',
    fi: 'fi',
    it: 'it',
};

export const LOCALE_LABELS = {
    en: 'English',
    de: 'Deutsch',
    ru: 'Русский',
    nl: 'Nederlands',
    zh: '中文',
    fi: 'Suomi',
    it: 'Italiano',
};

export function isSupportedLocale(value) {
    return SUPPORTED_LOCALES.includes(value);
}

export function getLocaleFromPathname(pathname = '') {
    const segments = String(pathname).replace(/\/+$/, '').split('/').filter(Boolean);
    if (segments[0] && isSupportedLocale(segments[0]) && segments[0] !== DEFAULT_LOCALE) {
        return segments[0];
    }
    return DEFAULT_LOCALE;
}

export function stripLocaleFromPathname(pathname = '') {
    const segments = String(pathname).replace(/\/+$/, '').split('/').filter(Boolean);
    if (segments[0] && isSupportedLocale(segments[0]) && segments[0] !== DEFAULT_LOCALE) {
        const rest = segments.slice(1).join('/');
        return rest ? `/${rest}` : '/';
    }
    return pathname || '/';
}

export function localizedPath(path = '/', locale = DEFAULT_LOCALE) {
    const normalized = !path || path === '/' ? '/' : (path.startsWith('/') ? path : `/${path}`);
    if (!locale || locale === DEFAULT_LOCALE) {
        return normalized;
    }
    if (normalized === '/') {
        return `/${locale}`;
    }
    return `/${locale}${normalized}`;
}

export function buildAlternateLinks(path = '/') {
    const base = stripLocaleFromPathname(path.startsWith('/') ? path : `/${path}`);
    return SUPPORTED_LOCALES.flatMap((locale) => ([
        {
            hrefLang: LOCALE_HREFLANG[locale] || locale,
            href: localizedPath(base, locale),
        },
    ])).concat([
        {
            hrefLang: 'x-default',
            href: localizedPath(base, DEFAULT_LOCALE),
        },
    ]);
}

export function getActiveMenuSlug(pathname = '') {
    const stripped = stripLocaleFromPathname(pathname);
    if (!stripped || stripped === '/') {
        return '';
    }
    const segments = stripped.split('/').filter(Boolean);
    return segments[segments.length - 1] || '';
}
